const GooeySVG = () => (
  <svg className="gooey-svg" xmlns="http://www.w3.org/2000/svg" version="1.1">
    <defs>
      <filter id="goo">
        <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
        <feColorMatrix
          in="blur"
          mode="matrix"
          values="1 0 0 0 0
                  0 1 0 0 0
                  0 0 1 0 0
                  0 0 0 19 -9"
          result="goo"
        />
        <feFlood floodColor="#3B82F6" result="flood" />
        <feComposite in="flood" in2="goo" operator="in" result="coloredGoo" />
        <feComposite in="SourceGraphic" in2="coloredGoo" operator="atop" />
      </filter>
    </defs>
  </svg>
);

export default GooeySVG;
